module.exports = __webpack_public_path__ + "img/TWCNVWEB-front.4ef63e65.jpg";